import * as leaveEntitlementAction from './leave-entitlement-action'

export {
  leaveEntitlementAction,
}



// WEBPACK FOOTER //
// ./src/actions/leave-entitlement/index.js